import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileLines } from '@fortawesome/free-regular-svg-icons';
import * as Store from '@apply/store';
import { Button, ButtonTheme, IconButton, IconButtonSize, IconButtonTheme } from '@apply/components';
import { mapType, formatDate } from './../NoticesBase.tsx';
import { faTrashCan } from '@fortawesome/free-regular-svg-icons';
import { useState } from 'react';
import { ConfirmV2 } from '@apply/ui';

export interface MobileNoticesProps {
    notices: Store.UserStore.Types.UserNoticeLean[] | undefined;
    onClickViewNotice: (noticeId: number) => void;
    deleteNotice: (noticeId: number) => void;
}

export const MobileNotices = ({ notices, onClickViewNotice, deleteNotice }: MobileNoticesProps) => {
    const [noticeIdToDelete, set_noticeIdToDelete] = useState<number | undefined>(undefined);

    const onConfirm = () => {
        if (noticeIdToDelete) deleteNotice(noticeIdToDelete);
        set_noticeIdToDelete(undefined);
    };

    const onCancel = () => {
        set_noticeIdToDelete(undefined);
    };

    return (
        <div className='mobile-notices-body'>
            {notices?.map((notice) => {
                const isUnread = !notice.isRead;

                const paragraphClass = isUnread
                    ? 'mobile-notices-address-block-p mobile-notices-bold-text'
                    : 'mobile-notices-address-block-p';

                const noticeClass = isUnread ? 'mobile-notices-type-style mobile-notices-type-bold' : 'mobile-notices-type-style';

                const needsSigning =
                    notice.eSignTypeId !== Store.UserStore.Types.ESignType.NotRequired && !notice.eSignDate?.isValid();

                let actionElement = null;
                if (needsSigning && !notice.isManual) {
                    actionElement = (
                        <Button
                            id={'view-sign-button-mobile-' + notice.id}
                            key={'view-sign-button-mobile-' + notice.id}
                            theme={ButtonTheme.Tertiary}
                            handleClick={() => onClickViewNotice(notice.id)}
                            width='200px'
                        >
                            View & Sign
                        </Button>
                    );
                } else {
                    actionElement = (
                        <a
                            className='mobile-notices-action-link'
                            onClick={() => {
                                if (notice.isManual) {
                                    window.open((notice.signedFile || notice.noticeFile).url, '_blank');
                                } else {
                                    onClickViewNotice(notice.id);
                                }
                            }}
                        >
                            <FontAwesomeIcon
                                icon={faFileLines}
                                className='mobile-notices-action-link-icon'
                            />
                            {notice.isManual ? 'Download Document' : 'View Document'}
                        </a>
                    );
                }

                const dateBlockHeight = needsSigning && !notice.isManual ? 100 : 80;
                return (
                    <div
                        key={notice.id}
                        className='mobile-notices-header'
                    >
                        <div className='mobile-notices-address-block'>
                            {notice.addresses?.[0] && (
                                <div>
                                    <p className={noticeClass}>{mapType(notice.noticeTypeId)}</p>
                                    <p className={paragraphClass}>{notice.addresses[0].street1}</p>
                                </div>
                            )}
                            {actionElement}
                        </div>
                        <div
                            className='mobile-notices-date-block'
                            style={{ height: dateBlockHeight }}
                        >
                            <p>{formatDate(notice.noticeDate, 'M/D/YYYY')}</p>
                            <IconButton
                                id='Delete Notice'
                                theme={IconButtonTheme.Red}
                                handleClick={() => set_noticeIdToDelete(notice.id)}
                                size={IconButtonSize.Small}
                                icon={faTrashCan}
                                hint='Delete Notice'
                                disabled={!notice.canDelete}
                            />
                        </div>
                    </div>
                );
            })}
            <ConfirmV2
                id='confirmDeleteNoticeModal'
                open={!!noticeIdToDelete}
                title='Delete Confirmation'
                onConfirm={onConfirm}
                onCancel={onCancel}
                okLabel='Yes'
                cancelLabel='No'
                width='340px'
                height='200px'
            >
                Are you sure you want to delete this notification? The notification will no longer be visible.
            </ConfirmV2>
        </div>
    );
};
